module.exports = __webpack_public_path__ + "img/map.d42365e3.jpg";